<template>
    <div class="bg-white">
        <template v-if="securing && !secured">
            <div class="p-5 md:py-12 xl:py-24 2xl:py-32 login-page border-b border-gray-200">
                <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                        <div class="faded border-gray-200 border p-4 rounded-t-lg" v-if="securePhase === 1">
                            <button type="button" class="bg-yellow-300 w-full justify-center text-white items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent shadow-sm leading-4 font-medium rounded-md " disabled>
                                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>

                                Securing...
                                </button>

                            <p class="leading-tight mt-6">Please wait while we obtain a secure connection</p>
                        </div>
                </div>
            </div>
        </template>

        <template v-if="secured">
            <div class="p-5 md:py-12 xl:py-24 2xl:py-32 login-page border-b border-gray-200">

                <div v-if="firstOffer" class="alerted border rounded-lg mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4 mb-4">
                    <div class="alerted border-b p-3 text-sm font-medium">

                        Hello {{ firstOffer.first_name }}, your account with {{ firstOffer.lender }} has been approved for {{ firstOffer.offer.discount }}% off. Login now to take advantage or view other options!

                    </div>
                    <div class="p-4 bg-white rounded-b-lg text-center">

                        <p v-if="offerText" v-html="offerText.offerTextTops.join('<br />')" class="text-gray-600 font-semibold text-base" />
                        <p v-if="offerText" v-html="offerText.offerTextBottoms.join('<br />')" class="font-medium text-sm" />

                    </div>
                </div>

                <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                    <div class="faded border-gray-200 border p-4 rounded-t-lg">
                        <div class="flex mb-3 text-sm text-green-500 font-medium" v-if="showSecureMessage">
                            Secure connection obtained!
                        </div>

                        <a v-if="$parent.isHalsted" href="#" class="flex-shrink-0 group block">
                            <div class="flex items-center">
                                <div>
                                    <svg class="inline-block h-8 w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p :class="`font-medium text-${$root.theme}-600`">
                                        {{ helloLineText }}
                                    </p>
                                </div>
                            </div>
                        </a>

                        <h1 class="font-semibold text-2xl mb-1 mt-2">Sign In</h1>
                        <p v-if="! secondError" class="leading-tight">To view your account with {{ consumerPortalName }} please enter your {{ form.use_name ? 'name' : form.use_number ? 'name': 'reference number' }} below:</p>

                    </div>
                    <div class="faded border-gray-200 border-b border-l border-r px-5 rounded-b-lg pt-2 pb-6">
                        <form @submit.prevent="login">

                        <template v-if="! secondError && shouldUse !== 'call-in'">
                            <div class="flex justify-end">
                                <h6 id="use-account-id" v-if="form.use_number || form.use_name" @click="useByReference" :class="`text-xs font-medium mb-2 cursor-pointer text-${$root.theme}-600`">
                                    I know my reference number
                                </h6>
                                <h6 id="use-name" v-else-if="shouldUseNumber" @click="useByNumber" :class="`text-xs font-medium text-right mb-2 cursor-pointer text-${$root.theme}-600`">
                                    Look up by first and last name
                                </h6>
                                <h6 id="use-name" v-else-if="shouldUseName" @click="useByName" :class="`text-xs font-medium mb-2 cursor-pointer text-${$root.theme}-600`">
                                    Look up by first and last name
                                </h6>
                            </div>

                            <using-name-form
                                v-if="form.use_name"
                                :first_name.sync="form.first_name"
                                :last_name.sync="form.last_name" />
                            <template v-else-if="form.use_number">
                                <using-name-form
                                    :first_name.sync="form.first_name"
                                    :last_name.sync="form.last_name" />
                                <using-number-form :number.sync="form.phone_number" class="mt-2" />
                            </template>
                            <using-reference-form v-else
                                :account_id.sync="form.account_id"
                                @show-find-reference="$parent.showingModal.findReference = true" />

                            <confirm-zip v-if="! secondError && shouldUse === 'zip'"
                                :zip.sync="form.zip"
                                :address="address"
                                @submit="login" />

                            <confirm-dob v-else-if="! secondError && shouldUse === 'dob'"
                                :month.sync="month"
                                :day.sync="day"
                                :ssn="! error && (canUseSsn || ! form.use_name)"
                                @submit="login"
                                @use-primary="useSecondary = false" />

                            <confirm-ssn v-else-if="! secondError && shouldUse === 'ssn'"
                                :ssn.sync="form.ssn_last_four"
                                :dob="! error && ! form.use_name && hasDob"
                                @submit="login"
                                @use-secondary="useSecondary = true"
                            />
                        </template>
                        <div v-else-if="secondError || shouldUse === 'call-in'">
                            <p class="font-medium text-center p-2">
                                <template v-if="data.hasOwnProperty('consumerPortalNumber') && data.hasOwnProperty('consumerPortalEmail')">
                                    In order to proceed please contact our office at
                                    <a :class="`font-semibold text-${$root.theme}-500 whitespace-nowrap`" :href='`tel:${data.consumerPortalNumber}`'>
                                        <svg class="inline-block w-5 h-5 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                        </svg>{{ data.consumerPortalNumber }}
                                    </a>
                                    or email us at
                                    <a :class="`font-semibold text-${$root.theme}-500 whitespace-nowrap`" :href='`tel:${data.consumerPortalEmail}`'>
                                        {{ data.consumerPortalEmail }}
                                    </a>
                                </template>
                                <template v-else-if="data.hasOwnProperty('consumerPortalNumber') && ! data.hasOwnProperty('consumerPortalEmail')">
                                    In order to proceed please contact our office at <a :href="`tel:${data.consumerPortalNumber}`" :class="`font-semibold text-${$root.theme}-500`">{{ data.consumerPortalNumber }}.</a>
                                </template>
                                <template v-else-if="data.hasOwnProperty('consumerPortalEmail') && ! data.hasOwnProperty('consumerPortalNumber')">
                                    In order to proceed please email our office at <a :href="`mailto:${data.consumerPortalEmail}`" :class="`font-semibold text-${$root.theme}-500`">{{ data.consumerPortalEmail }}.</a>
                                </template>
                            </p>
                        </div>

                        <div v-if="! secondError && shouldUse !== 'call-in'" class="mt-2">
                            <div class="flex mb-3 text-sm text-red-500 font-medium" v-if="error && error.body.errors === 'invalid_ssn' && shouldUse === 'zip'">
                                The SSN entered does not match our records, please enter your zip code.
                            </div>
                            <div class="flex mb-3 text-sm text-red-500 font-medium" v-else-if="error && error.body.errors === 'invalid_ssn' && shouldUse === 'yob'">
                                The SSN entered does not match our records, please enter your birthday.
                            </div>
                            <div class="flex mb-3 text-sm text-red-500 font-medium" v-else-if="error && error.body.errors === 'invalid_yob' && shouldUse === 'zip'">
                                The birth date entered does not match our records, please enter your zip code.
                            </div>
                            <div class="flex mb-3 text-sm text-red-500 font-medium" v-else-if="error && shouldUse !== 'dob' && ! accountId">
                                The information provided does not match an account in our office, please try again.
                            </div>
                            <div class="flex px-4 mb-2 items-center" v-show="false">
                                <input v-model="form.remember" id="remember" name="remember" type="checkbox" :class="`h-4 w-4 text-${$root.theme}-600 focus:ring-${$root.theme}-500 border-gray-300 rounded`">
                                <label class="ml-3 cursor-pointer" for="remember" id="annual-billing-label text-left">
                                    <span class="text-sm font-medium text-gray-900">Remember me</span>
                                </label>
                            </div>
                            <button type="submit" id="login-continue-button" :class="`w-full justify-center text-white items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent shadow-sm leading-4 font-medium rounded-md bg-${$root.theme}-600 hover:bg-${$root.theme}-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-200 ${! readyToSubmit ? 'cursor-not-allowed opacity-50' : ''}`">
                                <svg class="-ml-0.5 mr-3 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                                </svg>
                                Continue
                            </button>
                        </div>
                        <div class="mt-8">
                            <p class="text-xs leading-tight font-medium" v-if="$parent.isHalsted || $parent.isDynamic">
                                <template v-if="$parent.hasTermsAndConditions">
                                    By continuing you agree to our <a @click.prevent="$parent.showingModal.termsOfUse = true" :class="`text-${$root.theme}-500 font-medium cursor-pointer`">Terms and Conditions.</a>
                                </template>
                                This communication is from a debt collector. This is an attempt to collect a debt and any information obtained will be used for that purpose.
                            </p>
                        </div>

                        </form>
                    </div>
                </div>
            </div>
    <!--        <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4 flex items-center">-->
    <!--            <div class="flex-1 p-8">-->
    <!--                <h1 class="text-primary font-black text-4xl mb-2">Get back to doing what you love.</h1>-->
    <!--                <p class="leading-snug font-medium">{{ consumerPortalName }} has helped countless consumers gain control of their financial obligations. See what offers we have for you.</p>-->
    <!--            </div>-->
    <!--        </div>-->
        </template>
    </div>
</template>

<script>
    import Mixins from '../mixins';
    import ConfirmSsn from './Login/ConfirmSsn';
    import ConfirmDob from './Login/ConfirmDob';
    import ConfirmZip from './Login/ConfirmZip';
    import UsingNameForm from './Login/ByName';
    import UsingNumberForm from './Login/ByNumber';
    import UsingReferenceForm from './Login/ByRef';
    import OfferText from "../mixins/OfferText";

    export default {
        mixins: [Mixins, OfferText],

        components: {
            ConfirmSsn,
            ConfirmDob,
            ConfirmZip,
            UsingNameForm,
            UsingNumberForm,
            UsingReferenceForm
        },

        props: [
            'data',
            'address-attr',
            'account-id',
            'can-use-ssn',
            'can-use-zip',
            'has-dob',
            'dob',
            'should-use-name',
            'should-use-number',
            'referral',
            's-referral',
            'first-offer',
            'autoSecure',
            'helloLineText',
        ],

        computed: {
            readyToSubmit() {
                if (this.form.use_name) {
                    if (this.form.first_name.length === 0 || this.form.last_name.length === 0) return false;
                } else if (this.form.use_number) {
                    if (
                        this.form.phone_number.length !== 10
                        || ! this.form.first_name.length
                        || ! this.form.last_name.length
                    ) return false;
                } else {
                    if (! this.form.account_id.length || this.form.account_id === '') return false;
                }

                if (this.shouldUse === 'ssn') {
                    if (this.form.ssn_last_four.length !== 4) return false;
                } else if (this.shouldUse === 'dob') {
                    if (this.month === null || this.day === null) return false;
                } else if (this.shouldUse === 'zip') {
                    if (this.form.zip.length !== 5) return false;
                }

                return true;
            },

            shouldUse() {
                // organic
                if (! this.accountId) {
                    // no error but using ref #
                    if (! this.error && ! this.form.use_name && ! this.form.use_number) {
                        // secondary toggle
                        return ! this.useSecondary ? 'ssn' : 'dob';
                    }

                    if (this.error) {
                        // error but account has dob
                        if (this.canTryDobAfterFirstError) {
                            return 'dob';
                        }

                        // error
                        return 'ssn';
                    }

                    // no error first attempt
                    return 'ssn';
                }

                // referrals = nightmare
                if (this.canUseSsn) {
                    if (! this.hasDob) {
                        if (! this.canUseZip) {
                            return ! this.error ? 'ssn' : 'call-in';
                        }

                        return ! this.error ? 'ssn' : 'call-in';
                    }

                    if (this.useSecondary && ! this.form.use_name) {
                        return ! this.error ? 'dob' : 'call-in';
                    }

                    return ! this.error ? 'ssn' : 'call-in';
                } else if (this.canUseZip) {
                    if (! this.hasDob) {
                        return ! this.error ? 'zip' : 'call-in';
                    }

                    return ! this.error ? 'dob' : 'call-in';
                } else if (this.hasDob) {
                    return ! this.error ? 'dob' : 'call-in';
                }

                return 'call-in';
            },

            /**
             * @return {String}
             */
            consumerPortalName() {
                return this.data.consumerPortalName;
            },

            /**
             * @return {String}
             */
            consumerPortalBaseUrl() {
                return this.data.consumerPortalBaseUrl;
            }
        },

        data() {
            return {
                month: null,
                day: null,
                year: null,
                error: false,
                secondError: false,
                address: '',
                offerText: null,
                form: {
                    zip: '',
                    last_name: '',
                    first_name: '',
                    phone_number: '',
                    use_name: null,
                    use_number: null,
                    remember: false,
                    account_id: null,
                    ssn_last_four: ''
                },
                canTryDobAfterFirstError: false,
                securing: false,
                secured: false,
                securePhase: 1,
                showSecureMessage: false,
                useSecondary: false
            }
        },

        mounted() {
            this.address = this.addressAttr;

            this.gtagEvent('loaded-login');
            this.fbEvent('ViewContent');

            this.form.account_id = this.accountId;

            this.form.use_number = this.shouldUseNumber;

            if (! this.form.use_number && this.shouldUseName) {
                this.form.use_name = this.shouldUseName;
            }

            // We want to log a visit after they've remained on the page for at least 5 seconds...
            if (this.accountId) {
                setTimeout(() => {
                   this.$http.post(`${this.consumerPortalBaseUrl}/api/visits`, {
                       account_id: this.accountId,
                       referral: this.referral
                   });
               }, 5000);
            }

            if (this.firstOffer) {
                this.offerText = this.getOfferText(this.firstOffer.offer, this.firstOffer.current_balance);
            }

            if (this.autoSecure) {
                this.securing = false;
                this.secured = true;
            }
            else {
                this.securing = true;

                setTimeout(() => {
                    this.securing = false;
                    this.secured = true;
                    this.showSecureMessage = true;

                    setTimeout(() => {
                        this.showSecureMessage = false;
                    }, 3000);
                }, 3000);
            }
        },

        methods: {
            useByReference() {
                this.form.use_name = false;
                this.form.use_number = false;
            },

            useByName() {
                this.form.use_name = true;
                this.form.use_number = false;
            },

            useByNumber() {
                this.form.use_name = false;
                this.form.use_number = true;
            },

            /**
             * @param {Object} selectedDetails
             * @return {void}
             */
            login(selectedDetails) {
                if (! this.readyToSubmit) return;

                let payload = {
                    ...this.form,
                    ...{
                        account_id: this.form.account_id ? this.form.account_id : this.accountId,
                        referral: this.referral,
                        s_referral: this.sReferral,
                        should_use: this.shouldUse
                    }
                };

                if (typeof selectedDetails !== 'undefined' && typeof selectedDetails.id !== 'undefined') {
                    payload = {
                        ...payload,
                        ...{
                            account_id: selectedDetails.id,
                            ssn_last_four: selectedDetails.ssn_last_four,
                            zip: selectedDetails.zip,
                            first_name: '',
                            last_name: '',
                            use_name: false
                        }
                    };
                }

                if (this.shouldUse === 'dob') {
                    payload.dob = `${this.month}/${this.day}`;
                }

                this.$root.$emit('loading');

                this.$http.post(`${this.consumerPortalBaseUrl}/api/account-verification`, payload).then(({ data }) => {
                    if (typeof data.accounts !== 'undefined') {
                        this.$root.$emit('loading');
                        this.$root.$emit('select-account-for-login', data.accounts);
                    } else {
                        this.gtagEvent('login-successful');

                        if (data.is_first_login) {
                            this.gtagEvent('first-login-attempt');
                        }

                        setTimeout(() => {
                            if (! data.show_agreement) {
                                this.$nextTick(() => window.location = `${this.consumerPortalBaseUrl}${data?.route || '/early-payoff'}`);
                            } else {
                                this.$root.$emit('agreement', {
                                    agreement: data.agreement,
                                    callback: () => {
                                        this.$nextTick(() => window.location = `${this.consumerPortalBaseUrl}${data?.route || '/early-payoff'}`);
                                    }
                                });
                            }
                        }, 1000);
                    }
                }, error => {
                    this.form.ssn_last_four = '';
                    this.form.zip = '';

                    if (this.error) {
                        this.secondError = error;
                    } else {
                        this.error = error;

                        if (error.body.hasOwnProperty('has_dob')) {
                            this.canTryDobAfterFirstError = error.body.has_dob;
                        }
                    }

                    if (error.body.hasOwnProperty('address') && error.body.address) {
                        this.address = error.body.address;
                    }

                    this.$root.$emit('loading');
                    this.gtagEvent('login-failed');
                });
            }
        }
    }
</script>
